// Non-blocking user feedback for API helpers (replaces window.alert).
// A helper calls `notify(...)` / `notifyError(...)` (or utils/errors/presentError.reportApiError for a failed API call);
// <ApiNoticeHost /> (mounted by the context provider) renders it. Notices with the same key are shown once per `ttl`, so a
// failing request that several components repeat does not stack notices.
export const NOTIFY_EVENT = "lud:notify";
export const NOTICE_LEVELS = Object.freeze(["error", "warning", "info"]);

const lastShown = new Map();

export const resetNotifyDedupe = () => lastShown.clear();

/**
 * @param {string | {en: string, ar?: string}} message
 * @param {{ key?: string, ttl?: number, level?: "error" | "warning" | "info", requestId?: string }} [options]
 * @returns {boolean} true when the notice was dispatched, false when deduplicated
 */
export const notify = (message, { key, ttl = 10000, level = "error", requestId } = {}) => {
  if (typeof window === "undefined" || !message) return false;
  const dedupeKey = key || (typeof message === "string" ? message : message?.en) || "error";
  const now = Date.now();
  const previous = lastShown.get(dedupeKey);
  if (previous !== undefined && now - previous < ttl) return false;
  lastShown.set(dedupeKey, now);
  window.dispatchEvent(
    new CustomEvent(NOTIFY_EVENT, {
      detail: { id: `${dedupeKey}:${now}`, key: dedupeKey, level: NOTICE_LEVELS.includes(level) ? level : "error", message, requestId },
    }),
  );
  return true;
};

export const notifyError = (message, options = {}) => notify(message, { ...options, level: "error" });
